import { giveawayEndpointIds } from 'root/src/shared/giveaways/giveaways.constants';
import { authenticationTypes, userGroups } from 'root/src/shared/constants/auth';
import { otherEndpointType } from 'root/src/shared/descriptions/endpoints/lenses';
const cancelGiveawayPayloadSchema = {
    type: 'object',
    properties: {
        giveawayId: {
            type: 'string',
        },
        cancelScheduler: {
            type: 'boolean',
        },
    },
    required: ['giveawayId'],
};
export const cancelGiveawayEndpoint = {
    [giveawayEndpointIds.CANCEL_GIVEAWAY]: {
        authentication: authenticationTypes.authenticated,
        authenticationRole: userGroups.admin,
        endpointType: otherEndpointType,
        payloadSchema: cancelGiveawayPayloadSchema,
    },
};
